/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-alert */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Row, Col, Card, CardBody, CardTitle, NavItem, NavLink, InputGroup,
  TabContent, TabPane, Nav, Collapse, Button, CardHeader,
} from 'reactstrap';
import classnames from 'classnames';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { withTranslation } from 'react-i18next';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import moment from 'moment';
import BaseGrid from '../../components/Common/BaseGrid';
import KitForm from '../../components/Inventory/KitForm';

import { get, post } from '../../helpers/api_helper';

function ViewKit(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t } = props;
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const [activeTab, setActiveTab] = useState('1');
  const [isGallery, setIsGallery] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const [editCollapse, setEditCollapse] = useState(false);
  const [increment, setIncrement] = useState(-0);
  const [signal, setSignal] = useState(0);

  const copyToClipboard = async (value) => {
    if (!value) {
      return;
    }

    try {
      await navigator.clipboard.writeText(String(value));
      toastr.success(t('Copied to clipboard'), t('Success'));
    } catch (err) {
      toastr.error(t('Unable to copy'), t('Error'));
    }
  };

  const renderCopyableValue = (value) => {
    if (!value) {
      return '-';
    }

    return (
      <span className="d-inline-flex align-items-center gap-2">
        <span>{value}</span>
        <small>
          <button
            type="button"
            className="btn btn-link btn-sm p-0 border-0 text-muted align-baseline"
            title={t('Copy')}
            aria-label={t('Copy')}
            onClick={() => copyToClipboard(value)}
          >
            <i className="mdi mdi-content-copy font-size-14" aria-hidden="true" />
          </button>
        </small>
      </span>
    );
  };

  const getPartNumbers = (kit) => {
    if (!kit?.items) {
      return '-';
    }

    const partNumbers = kit.items
      .map((item) => item?.inventory?.part_number)
      .filter(Boolean);

    return partNumbers.length > 0 ? partNumbers.join(', ') : '-';
  };

  const toggle = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const kit = await get(`/api/inventory/kit/get/${id}`);

        setData(kit);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };

    setLoading(true);
    fetchData();
  }, [refresh]);

  const onSuccess = () => {
    setRefresh(refresh + 1);
    setEditCollapse(false);
  };

  const incrementQty = async (e) => {
    e.preventDefault();

    try {
      await post(`/api/inventory/kit/increment/${id}?inc=${increment}`);
      setRefresh(refresh + 1);
      setIncrement(-0);
      toastr.success(t('Quantity updated'));
    } catch (err) {
      toastr.error(err.message);
    }
  };

  const deleteKit = async (row) => {
    if (window.confirm(props.t('Are you sure you want to delete this kit?'))) {
      await post('/api/inventory/kit/delete', { id: row.id });
      setSignal(signal + 1);
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col lg="12">
            <Collapse isOpen={editCollapse}>
              <Row>
                <Col xxl="8">
                  <Card>
                    <CardBody>
                      <CardTitle className="h4">{t('Edit Kit')}</CardTitle>
                      {data !== null && (
                        <KitForm actionUrl="/api/inventory/kit/save" entity={data} onSuccess={onSuccess} />
                      )}
                      <Button
                        type="submit"
                        color="secondary"
                        form="KitEditForm"
                        className="float-end"
                      >
                        {t('Save Changes')}
                      </Button>
                      <Button
                        type="button"
                        color="dark"
                        onClick={() => { setEditCollapse(false); }}
                        className="float-end me-3 btn-soft-dark"
                      >
                        {t('Cancel')}
                      </Button>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Collapse>

            <Collapse isOpen={!editCollapse}>
              <Row>
                <Col md="5">
                  <Card>
                    <CardHeader className="text-uppercase bg-transparent border-bottom">{t('Details')}</CardHeader>
                    <CardBody>
                      <table className="table table-bordered table-striped mt-3">
                        <tbody>
                          <tr>
                            <th>{t('Stock ID')}</th>
                            <td>{loading === true ? t('Loading...') : renderCopyableValue(data.stock_id)}</td>
                          </tr>
                          <tr>
                            <th>{t('Sku')}</th>
                            <td>{loading === true ? t('Loading...') : renderCopyableValue(data.sku)}</td>
                          </tr>
                          <tr>
                            <th>{t('Part Number')}</th>
                            <td>{loading === true ? t('Loading...') : getPartNumbers(data)}</td>
                          </tr>
                          <tr>
                            <th>{t('Box Size')}</th>
                            <td>{loading === true ? t('Loading...') : (data.box?.box_name || '-')}</td>
                          </tr>
                          <tr>
                            <th>{t('Qty On Shelf')}</th>
                            <td>{loading === true ? t('Loading...') : data.qty}</td>
                          </tr>
                          <tr>
                            <th>{t('Default Ship Weight')}</th>
                            <td>{loading === true ? t('Loading...') : data.ship_weight}</td>
                          </tr>
                          <tr>
                            <th>{t('Default Ship Dimensions')}</th>
                            <td>{loading === true ? t('Loading...') : data.ship_dims}</td>
                          </tr>
                        </tbody>
                      </table>

                      <Button color="warning" title={t('Edit Item')} className="btn-soft-warning text-dark" onClick={() => { setEditCollapse(true); }}>
                        <span className="mdi mdi-pencil" />
                      </Button>

                      <Button color="danger" title={t('Delete Item')} className="ms-2 btn-soft-danger text-dark" onClick={() => { deleteKit(data); }}>
                        <span className="mdi mdi-delete" />
                      </Button>
                    </CardBody>
                  </Card>

                  <Card>
                    <CardHeader className="text-uppercase bg-transparent border-bottom">{t('Quantity')}</CardHeader>
                    <CardBody>
                      <form method="post" action={`/api/inventory/kit/increment/${id}`} onSubmit={incrementQty}>
                        <InputGroup>
                          <input type="number" className="form-control" step="1" name="inc" onChange={(e) => { setIncrement(e.target.value); }} value={increment} />
                          <Button type="submit" color="primary" className="btn-soft-primary">
                            {t('Increment')}
                          </Button>
                        </InputGroup>

                        <p className="pt-2 mb-2">{t('Modify the qty up or down by this number.')}</p>
                        <span className="text-danger">
                          {t('Projected qty')}
                          {': '}
                          {loading === true ? t('Loading...') : data.qty + parseInt(increment, 10)}
                        </span>
                      </form>
                    </CardBody>
                  </Card>

                  {process.env.REACT_APP_STATIC_INVENTORY !== '1' && (
                  <Card className="mt-3">
                    <CardHeader className="text-uppercase bg-transparent border-bottom">{t('History')}</CardHeader>
                    <CardBody>
                      {data !== null && (
                      <BaseGrid
                        url="/api/warehouse/location/logs"
                        filters={`pll.stock_id=${data.stock_id}`}
                        hasSearch
                        className="table table-striped table-bordered table-sm fs-5"
                        config={
                          {
                            columns: {
                              physical_location_label: {
                                label: 'Location',
                                class: 'fs-6',
                              },
                              user: {
                                label: 'User',
                                class: 'fs-6',
                              },
                              action: {
                                label: 'Action',
                                class: 'fs-6',
                              },
                              qty: {
                                label: 'Qty',
                                class: 'fs-6',
                              },
                              created_at: {
                                label: 'Date',
                                date: {
                                  format: (date) => (moment(date).fromNow()),
                                  timezone: process.env.REACT_APP_LOCAL_TZ,
                                },
                                class: 'fs-6',
                              },
                            },
                            pagination: {
                              sort: 'id',
                              direction: 'DESC',
                              perPage: 6,
                            },
                          }
                        }
                      />
                      )}
                    </CardBody>
                  </Card>
                  )}
                </Col>

                <Col md="7">
                  <Card>
                    <CardHeader className="text-uppercase bg-transparent border-bottom">{t('Photo')}</CardHeader>
                    <CardBody>
                      {error !== null && (
                        <p className="text-danger">{error}</p>
                      )}
                      <div>
                        <div className="popup-gallery hstack gap-2">
                          {data !== null && data.image_url !== null && (
                            <div className="img-fluid">
                              <img
                                src={data.image_url !== '' && data.image_url !== null ? data.image_url : `/api/inventory/kit/thumbnail/${data.id}`}
                                alt="Item"
                                style={{
                                  cursor: 'pointer', width: '100%', maxWidth: '200px', maxHeight: '200px',
                                }}
                                onClick={() => { setIsGallery(true); }}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </CardBody>
                  </Card>

                  <Card>
                    <CardHeader className="text-uppercase bg-transparent border-bottom">{t('Stock')}</CardHeader>
                    <CardBody>
                      {data !== null && (
                      <BaseGrid
                        url="/api/warehouse/location/stock"
                        filters={`pli.stock_id=${data.stock_id}`}
                        className="table table-striped table-bordered table-sm fs-5"
                        config={
                          {
                            columns: {
                              zone: {
                                label: 'Zone',
                                sort: true,
                                format: (y, x) => x.location.zone,
                                class: 'fs-6',
                              },
                              location: {
                                label: 'Location',
                                sort: true,
                                format: (x) => x.label,
                                class: 'fs-6',
                              },
                              type: {
                                label: 'Type',
                                sort: true,
                                format: (f, x) => x.location.type,
                                class: 'fs-5',
                              },
                              qty: {
                                label: 'Qty',
                                sort: true,
                                class: 'fs-6',
                              },
                              lot: {
                                label: 'Lot',
                                class: 'fs-6',
                              },
                              serial: {
                                label: 'Serial',
                                class: 'fs-6',
                              },
                            },
                            pagination: {
                              sort: 'location',
                              direction: 'asc',
                              perPage: 5,
                            },
                          }
                        }
                      />
                      )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Collapse>
          </Col>
        </Row>

        <Row>
          <Col lg="12">
            <Nav tabs>
              <NavItem>
                <NavLink
                  style={{ cursor: 'pointer' }}
                  className={classnames({
                    active: (activeTab === '1'),
                  })}
                  onClick={() => {
                    toggle('1');
                  }}
                >
                  {t('Orders')}
                </NavLink>
              </NavItem>
            </Nav>

            <TabContent
              activeTab={activeTab}
            >
              <TabPane tabId="1">
                <Row>
                  <Col sm="12">
                    <Card>
                      <CardBody>
                        {data !== null && (
                        <BaseGrid
                          url={`/api/inventory/kit/orders/${data.id}`}
                          className="table table-striped table-bordered table-sm fs-5"
                          config={
                            {
                              columns: {
                                flag: {
                                  label: 'Flag',
                                  html: true,
                                  sort: true,
                                  alt: 'flag_message',
                                  format: (f) => {
                                    if (f === 1) {
                                      return '<span class="mdi mdi-flag text-danger fs-3" />';
                                    }

                                    return '<span />';
                                  },
                                },
                                reference: {
                                  label: 'Order Number',
                                  sort: true,
                                  link: {
                                    to: '/orders/%id%',
                                  },
                                },
                                created_at: {
                                  label: 'Imported',
                                  date: {
                                    format: (date) => (moment(date).fromNow()),
                                    timezone: process.env.REACT_APP_LOCAL_TZ,
                                  },
                                  sort: true,
                                },
                                ship_method: {
                                  label: 'Ship Method',
                                  sort: false,
                                  style: { maxWidth: '150px' },
                                },
                                customer_note: {
                                  label: 'Customer Note',
                                  sort: false,
                                  style: { maxWidth: '150px' },
                                },
                                customer_name: {
                                  label: 'Customer Name',
                                  format: (x, ord) => (ord.soldTo ? `${ord.soldTo.firstname} ${ord.soldTo.lastname}` : `${ord.shipTo.firstname} ${ord.shipTo.lastname}`),
                                },
                                items: {
                                  label: 'Items',
                                  sort: false,
                                  format: (x) => {
                                    if (x !== undefined) {
                                      return Math.round(x.reduce((sum, item) => sum + item.qty, 0));
                                    }

                                    return 0;
                                  },
                                },
                                picking: {
                                  label: 'Picking',
                                  html: true,
                                  format: (x, ord) => {
                                    const hasPickedItems = ord.items
                                      .some((item) => item.pickroute_items
                                        .filter((z) => z.void === 0).length > 0);

                                    if (hasPickedItems) {
                                      return '<span class="mdi mdi-checkbox-marked-outline text-success fs-3"></span>';
                                    }

                                    return '<span class="mdi mdi-checkbox-blank-outline text-default fs-3"></span>';
                                  },
                                },
                                packed: {
                                  label: t('Packed'),
                                  sort: false,
                                  html: true,
                                  format: (x, ord) => {
                                    const unshipped = ord.items.map(
                                      (y) => y.qty_unshipped,
                                    ).reduce((partialSum, a) => partialSum + a, 0);

                                    const itemsCount = ord.items.map(
                                      (y) => y.qty,
                                    ).reduce((partialSum, a) => partialSum + a, 0);

                                    if (unshipped > 0) {
                                      if (unshipped < itemsCount) {
                                        return '<span class="mdi mdi-checkbox-intermediate text-warning fs-3" />';
                                      }

                                      return '<span class="mdi mdi-checkbox-blank-outline text-default fs-3" />';
                                    }

                                    return '<span class="mdi mdi-checkbox-marked-outline text-success fs-3" />';
                                  },
                                },
                                shipped: {
                                  label: 'Shipped',
                                  sort: false,
                                  html: true,
                                  format: (x) => {
                                    if (x === 1) {
                                      return '<span class="mdi mdi-checkbox-marked-outline text-success fs-3" />';
                                    }

                                    return '<span class="mdi mdi-checkbox-blank-outline text-default fs-3" />';
                                  },
                                },
                                void: {
                                  label: 'Void',
                                  sort: false,
                                  html: true,
                                  format: (x) => {
                                    if (x === 1) {
                                      return '<strong class="mdi mdi-cancel text-danger fs-3" />';
                                    }

                                    return '<span />';
                                  },
                                },
                              },
                              pagination: {
                                sort: 'id',
                                direction: 'desc',
                                perPage: 30,
                              },
                            }
                          }
                        />
                        )}
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </TabPane>
            </TabContent>
          </Col>
        </Row>
      </div>

      {isGallery ? (
        <Lightbox
          mainSrc={data.image_url !== '' && data.image_url !== null ? data.image_url : `/api/inventory/thumbnail/${data.id}`}
          enableZoom={false}
          onCloseRequest={() => setIsGallery(false)}
          imageCaption={data.part_number}
        />
      ) : null}
    </div>
  );
}

ViewKit.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(ViewKit));
